import * as d3 from "d3";

export class InOutBoxes {
  private balanceGraph: any;
  private xScale: d3.ScaleTime<number, number, never>;
  private yScale: d3.ScaleLinear<number, number, never>;

  constructor(
    balanceGraph: any,
    xScale: d3.ScaleTime<number, number, never>,
    yScale: d3.ScaleLinear<number, number, never>,
  ) {
    this.balanceGraph = balanceGraph;
    this.xScale = xScale;
    this.yScale = yScale;
  }

  updateInBoxes(
    balanceByTime: Map<string, number>,
    insByTime: Map<string, number>,
    id: string = "inBoxes",
    selectedIndex?: number,
  ) {
    this.removeBoxes(id);

    if (selectedIndex === 0) {
      return;
    } else if (selectedIndex === null || selectedIndex === undefined) {
      let previousTime: string | null = null;
      let previousYBalance: number | null = null;
      balanceByTime.forEach((yBalance, time) => {
        if (previousTime === null) {
          previousTime = time;
          previousYBalance = yBalance;
          return;
        }
        this.drawInBox(previousTime, time, previousYBalance, insByTime, id);
        previousYBalance = yBalance;
        previousTime = time;
      });
    } else {
      const times = Array.from(balanceByTime.keys());
      const time = times[selectedIndex];
      const previousTime = times[selectedIndex - 1];
      const previousYBalance = balanceByTime.get(previousTime);
      this.drawInBox(previousTime, time, previousYBalance, insByTime, id);
    }
  }

  updateOutBoxes(
    balanceByTime: Map<string, number>,
    outsByTime: Map<string, number>,
    id: string = "outBoxes",
    selectedIndex?: number,
  ) {
    this.removeBoxes(id);
    if (selectedIndex === 0) {
      return;
    } else if (selectedIndex === null || selectedIndex === undefined) {
      let previousTime: string | null = null;
      let previousYBalance: number | null = null;
      balanceByTime.forEach((yBalance, time) => {
        if (previousTime === null) {
          previousTime = time;
          previousYBalance = yBalance;
          return;
        }
        this.drawOutBox(previousTime, time, previousYBalance, outsByTime, id);
        previousYBalance = yBalance;
        previousTime = time;
      });
    } else {
      const times = Array.from(balanceByTime.keys());
      const time = times[selectedIndex];
      const previousTime = times[selectedIndex - 1];
      const previousYBalance = balanceByTime.get(previousTime);
      this.drawOutBox(previousTime, time, previousYBalance, outsByTime, id);
    }
  }

  drawInBox(
    previousTime: string,
    time: string,
    previousYBalance: number,
    insByTime: Map<string, number>,
    id: string,
  ) {
    const x = this.xScale(new Date(Number(previousTime) * 1000));
    const y = this.yScale(previousYBalance + insByTime.get(time));
    const diffY =
      this.yScale(previousYBalance) - this.yScale(previousYBalance + insByTime.get(time));
    const diffX = this.xScale(new Date(Number(time) * 1000)) - x;

    if (diffY !== 0) {
      this.balanceGraph
        .append("rect")
        .attr("rx", 6)
        .attr("ry", 6)
        .attr("x", Math.abs(x))
        .attr("y", Math.abs(y))
        .attr("width", Math.abs(diffX))
        .attr("height", Math.abs(diffY))
        .attr("class", `in-boxes ${id}`)
        .attr("fill", "url(#gradientInBoxes)");
    }
  }

  drawOutBox(
    previousTime: string,
    time: string,
    previousYBalance: number,
    outsByTime: Map<string, number>,
    id: string,
  ) {
    const x = this.xScale(new Date(Number(previousTime) * 1000));
    const y = this.yScale(previousYBalance);
    const diffY =
      this.yScale(previousYBalance - outsByTime.get(time)) - this.yScale(previousYBalance);
    const diffX = this.xScale(new Date(Number(time) * 1000)) - x;

    if (diffY !== 0) {
      this.balanceGraph
        .append("rect")
        .attr("rx", 6)
        .attr("ry", 6)
        .attr("x", Math.abs(x))
        .attr("y", Math.abs(y))
        .attr("width", Math.abs(diffX))
        .attr("height", Math.abs(diffY))
        .attr("class", `out-boxes ${id}`)
        .attr("fill", "url(#gradientOutBoxes)");
    }
  }

  removeBoxes(className: string) {
    this.balanceGraph.selectAll(`.${className}`).remove();
  }
}
